import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Title = styled.div`
  display: flex;
  font-weight: ${({ isCampaignName }) => (isCampaignName ? "600" : "400")};
  font-size: ${({ isCampaignName }) => (isCampaignName ? "18px" : "11px")};
  color: ${({ theme, isCampaignName }) =>
    isCampaignName ? "white" : theme.colors.dataViz.headerSectionTitle};
  > div {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    word-break: break-word;
  }
`;

export const Children = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
